var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('btn-primary',{attrs:{"text":_vm.$t('app.financial.payableAccounts.list.terminateButton'),"type":"submit","flex-row-reverse":"","disabled":_vm.totalItens === 0},on:{"click":function($event){return _vm.confirmTerminatePayableAccounts()}}})}
var staticRenderFns = []

export { render, staticRenderFns }